// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"56d76837","316":"ed094a1c","775":"c00f9ab4","855":"eaf70366","940":"956a64a7"}[chunkId] + ".chunk.js";
};